<script lang="ts">
  import { ArrowDown, ArrowUp, Copy, MapPin, Trash2 } from '@lucide/svelte';
  import type { EventClassificationChoice } from '../lib/chart-model';
  import type { ParameterDefinition, PlotDefinition, PlotSpec } from '../lib/types';
  import PlotPanelHeaderOptions from './PlotPanelHeaderOptions.svelte';

  export let index: number;
  export let count: number;
  export let parameterName: string;
  export let plotName: string;
  export let plot: PlotSpec;
  export let parameter: ParameterDefinition;
  export let definition: PlotDefinition;
  export let selectedEventVisible: boolean;
  export let eventClassificationChoices: EventClassificationChoice[];
  export let hiddenEventClassificationKeys: Set<string>;
  export let visibleEventClassificationCount: number;
  export let locationName: string | undefined;
  export let independentTime: boolean;
  export let duplicateDisabled = false;
  export let onDuplicate: () => void;
  export let onMove: (direction: -1 | 1) => void;
  export let onRemove: () => void;
  export let onSetOption: (name: string, enabled: boolean) => void;
  export let onSetEventClassificationVisible: (key: string, visible: boolean) => void;
  export let onShowAllEventClassifications: () => void;
  export let onHideAllEventClassifications: () => void;
</script>

<header class="plot-panel__header">
  <div class="plot-panel__identity">
    <h2>Plot {index + 1}: {parameterName} — {plotName}</h2>
    <PlotPanelHeaderOptions
      {plot}
      {parameter}
      {definition}
      {selectedEventVisible}
      {eventClassificationChoices}
      {hiddenEventClassificationKeys}
      {visibleEventClassificationCount}
      {onSetOption}
      {onSetEventClassificationVisible}
      {onShowAllEventClassifications}
      {onHideAllEventClassifications}
    />
    {#if locationName}
      <span class="location-badge"><MapPin size={13} aria-hidden="true" /> {locationName}</span>
    {/if}
    {#if independentTime}<span class="time-badge">Independent time</span>{/if}
  </div>
  <div class="plot-actions" aria-label="Plot actions">
    <button class="icon-button" type="button" on:click={() => { if (!duplicateDisabled) onDuplicate(); }} disabled={duplicateDisabled} title={duplicateDisabled ? 'Plot limit reached' : 'Duplicate plot'} aria-label="Duplicate plot"><Copy size={17} /></button>
    <button class="icon-button" type="button" on:click={() => onMove(-1)} disabled={index === 0} title="Move plot up" aria-label="Move plot up"><ArrowUp size={17} /></button>
    <button class="icon-button" type="button" on:click={() => onMove(1)} disabled={index === count - 1} title="Move plot down" aria-label="Move plot down"><ArrowDown size={17} /></button>
    <button class="icon-button icon-button--danger" type="button" on:click={onRemove} title="Remove plot" aria-label="Remove plot"><Trash2 size={17} /></button>
  </div>
</header>
